module.exports = __webpack_public_path__ + "assets/images/new-activity-icon.86335f8a2f072069084e9f23a5bf4dbe.svg";